export default "__VITE_ASSET__CuAfnVfe__"